import { forwardRef, type SVGProps } from "react";
// eslint-disable-next-line react/display-name
const SvgCog = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="matrix(1.1308284,0,0,1.1311011,-21.865494,-13.101929)">
      <path
        d="m 29.0949,13.9421 c 0.2869,-2.0339 3.1867,-2.0339 3.4737,0 0.1983,1.4055 1.8638,2.0194 2.9078,1.0718 1.5108,-1.3712 3.7321,0.5164 2.661,2.2612 -0.7402,1.2058 0.146,2.7602 1.5472,2.714 2.0278,-0.067 2.5313,2.8249 0.6032,3.4643 -1.3323,0.4419 -1.6401,2.2095 -0.5373,3.0862 1.5958,1.2686 0.146,3.8118 -1.7369,3.0465 -1.301,-0.5288 -2.6588,0.6249 -2.3705,2.0143 0.4173,2.0107 -2.3076,3.0151 -3.2642,1.2032 -0.661,-1.252 -2.4334,-1.252 -3.0944,0 -0.9566,1.8119 -3.6815,0.8075 -3.2642,-1.2032 0.2883,-1.3894 -1.0694,-2.5431 -2.3705,-2.0143 -1.8828,0.7653 -3.3327,-1.7779 -1.7369,-3.0465 1.1028,-0.8767 0.795,-2.6443 -0.5373,-3.0862 -1.9281,-0.6394 -1.4245,-3.5313 0.6032,-3.4643 1.4012,0.0462 2.2874,-1.5082 1.5472,-2.714 -1.0711,-1.7448 1.1502,-3.6324 2.661,-2.2612 1.044,0.9476 2.7096,0.3337 2.9079,-1.0718 z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="30.83"
        cy="23.083401"
        r="2.7222199"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
));
export default SvgCog;
